import { Injectable, signal } from '@angular/core';
import { countries } from '@airwallet/data';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environment';
import { AW } from '@airwallet/types';
@Injectable({ providedIn: 'root' })
export class CountryService {
    sortedCountries = signal<string[]>([]);
    sortedCountriesWithCodes = signal<{ code: string; name: string }[]>([]);
    demoCountries = [
        { code: 'DK', country: 'Denmark' },
        { code: 'US', country: 'United States' },
        { code: 'FR', country: 'France' },
        { code: 'ES', country: 'Spain' },
        { code: 'AU', country: 'Australia' },
        { code: 'NZ', country: 'New Zealand' }
    ];
    constructor(translate: TranslateService) {
        const countryList: { code: string; name: string }[] = [];
        const countryToUse = environment.isDemo ? this.getCountries(this.demoCountries) : countries;
        for (const code in countryToUse) {
            const countryDetails = countryToUse[code];
            const translated = translate.instant(`country.${countryDetails.country.toLowerCase().replace(/ /g, '_')}`);
            countryList.push({
                code: code,
                name: translated
            });
        }

        countryList.sort((a, b) => {
            return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });
        });

        this.sortedCountries.set(countryList.map(country => country.name));
        this.sortedCountriesWithCodes.set(countryList);
    }

    get countries() {
        return this.sortedCountries();
    }

    get countriesWithCodes() {
        return this.sortedCountriesWithCodes();
    }

    getCountries(countriesToGet: { code: string; country: string }[]) {
        try {
            return countriesToGet.reduce(
                (acc, curr) => {
                    // Use the country code to get data from the countries object
                    if (countries[curr.code]) {
                        acc[curr.code] = countries[curr.code];
                    } else {
                        console.error('country-service/missing-country-data', { code: curr.code });
                    }
                    return acc;
                },
                {} as Record<string, AW.Misc.CountryDetails>
            );
        } catch (error) {
            console.error('country-service/get-countries-error', error, { countriesToGet });
            // Return an empty object as fallback
            return {} as Record<string, AW.Misc.CountryDetails>;
        }
    }
}
